export const CRIAR_RAMAL = 'CRIAR_RAMAL'
export const MUDAR_NUMERO_RAMAL = 'MUDAR_NUMERO_RAMAL'
export const LISTAR_RAMAIS = 'LISTAR_RAMAIS'
export const SELECIONAR_RAMAL = ' SELECIONAR_RAMAL'
export const LISTAR_TRONCOS = 'LISTAR_TRONCOS'
export const LISTAR_ROTAS = 'LISTAR_ROTAS'
export const LISTAR_GRUPOS = 'LISTAR_GRUPOS'
export const LISTAR_GRUPOS_DE_ROTAS = 'LISTAR_GRUPOS_DE_ROTAS'
